import { render, staticRenderFns } from "./WhiteLabel.vue?vue&type=template&id=4642d7f7&lang=pug"
import script from "./WhiteLabel.vue?vue&type=script&lang=js"
export * from "./WhiteLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports